<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">化学品采购审批</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="审批状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择">
            <el-option v-for="item in $store.state.reviewStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="status_text" label="状态" width="80">
        </custom-table-column>
        <custom-table-column prop="apply_structure_1" label="所属院系" width="180">
        </custom-table-column>
        <custom-table-column prop="apply_structure_2" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="180">
        </custom-table-column>
        <custom-table-column prop="grade" label="年级" width="160">
        </custom-table-column>
        <custom-table-column prop="apply_reason" label="申请理由" min-width="200px">
        </custom-table-column>
        <custom-table-column prop="review_name" label="审批人" width="100px">
        </custom-table-column>
        <custom-table-column prop="review_desc" label="说明原因" width="160px">
        </custom-table-column>
        <custom-table-column prop="review_time" label="审批时间" width="160px">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="detailMethod(scope.row)" type="text" size="small">详情</el-button>
            <el-button  v-if="scope.row.status == 1" @click="handleOper(scope.row, 2, '通过')" type="text" size="small">通过</el-button>
            <el-button  v-if="scope.row.status == 1" @click="handleOper(scope.row, 3, '否决')" type="text" size="small">否决</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="510px">
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="说明原因" prop="review_desc" :rules="isRefuse">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.review_desc"
            style="width:336px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm', setStatus)">提交</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="采购详情" :visible.sync="detailDialogVisible" width="746px">
      <el-descriptions class="margin-top" title="申请单" direction="vertical" :column="3" border v-if="rowObj">
        <!-- <el-descriptions-item>
          <template slot="label">采购类别 </template> {{ rowObj.type }}
        </el-descriptions-item> -->
        <el-descriptions-item>
          <template slot="label">审批状态 </template> {{ rowObj.status_text }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">说明原因 </template> {{ rowObj.review_desc }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">审批时间 </template> {{ rowObj.review_time }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">学年学期 </template> {{ rowObj.term }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">年 级 </template> {{ rowObj.grade }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">总采购金额 </template> {{ rowObj.total_amount }}元
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">所属院系 </template> {{ rowObj.apply_structure_1 }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">专业 </template> {{ rowObj.apply_structure_2 }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">申请理由 </template> {{ rowObj.apply_reason }}
        </el-descriptions-item>
      </el-descriptions>
      <p style="font-size: 16px;font-weight: 700;color:#111;margin-top:32px;margin-bottom:20px;">采购清单</p>
      <el-descriptions class="margin-top" title="" style="margin-bottom:16px;" v-for="(item, index) in rowObj.items"
        :key="index" direction="vertical" :column="5" size="small" border>
        <el-descriptions-item>
          <template slot="label">化学品名称</template> {{ item.name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">化学品数量 </template> {{ item.quantity }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">单 位</template> {{ item.unit }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">单 价 </template> {{ item.price }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">总 价 </template> {{ item.total_price }}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinOrgan, mixinFormatter],
  data() {
    return {
      formInline: {
        structure_1: '',
        structure_2: '',
        serial_no: '',
        device_name: '',
        training_room_id: '',
        status: '',
      },
      ruleForm: {
        id: '',
        status: '',
        review_desc: ''
      },
      rowObj:{},
      detailDialogVisible:false
    };
  },
  components: {},
  computed: {
    isRefuse() {
      return this.ruleForm.status == 3?[{ required: true, message: '请输入', trigger: 'blur' }]:[];
    },
  },
  created() {
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
  },
  methods: {
    handleOper(row, status,str) {
      this.ruleForm.id = row.id
      this.ruleForm.status = status
      this.centerDialogVisible = true
      this.title = `${str}的采购申请`
      // this.confirmBox('warning', `是否${str}${row.device_name}${row.device_individual?row.device_individual.serial_no:''}的维修申请`, { id:row.id, status }, this.setStatus);
    },
    async setStatus() {
      let res = await this.$api.instance.interfaceServer(`api/chemical/purchase/approve`, 'post', this.ruleForm);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '设置成功！',
        });
        this.centerDialogVisible = false
        this.getList();
      }
    },
    
    detailMethod(row) {
        this.rowObj = row;
        this.detailDialogVisible = true;
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/chemical/purchase/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.beforeQueryByKeyNew({major: "apply_structure_2", dep: 'apply_structure_1'});
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
